import { Component, OnInit, HostListener } from '@angular/core';


interface Servicio {
  titulo: string;
  descripcion: string;
  imagen: string;
  link: string;
}

@Component({
  selector: 'app-servicios-carousel',
  templateUrl: './servicios-carousel.component.html',
  styleUrls: ['./servicios-carousel.component.css']
})
export class ServiciosCarouselComponent implements OnInit {
  servicios: Servicio[] = [
    {
      titulo: 'Consultas médicas online 24hs.',
      descripcion: 'A través de vittal idoc, nuestros socios pueden realizar consultas médicas online desde cualquier lugar evitando guardias y traslados.',
      imagen: 'assets/img/home/icons.png',
      link: 'servicios-adicionales/idoc'
    },
    {
      titulo: 'Apto físico escolar',
      descripcion: 'Para los chicos y sin moverte de tu casa.',
      imagen: 'assets/img/home/icons-1.png',
      link: 'servicios-adicionales/apto-fisico-escolar-a-domicilio'
    },
    {
      titulo: 'Enfermería',
      descripcion: 'Asistencia de enfermeros con amplia experiencia profesional con respaldo vittal.',
      imagen: 'assets/img/home/icons-2.png',
      link: 'servicios-adicionales/enfermeria'
    },
    {
      titulo: 'Odontología',
      descripcion: 'Los socios pueden acceder a una membresía odontológica y servicio de urgencias.',
      imagen: 'assets/img/home/icons-3.png',
      link: 'servicios-adicionales/odontologia'
    },
    {
      titulo: 'Laboratorio',
      descripcion: 'Realización de análisis clínicos en centros médicos o a domicilio.',
      imagen: 'assets/img/home/icons-4.png',
      link: 'servicios-adicionales/laboratorio'
    },
    {
      titulo: 'Radiología',
      descripcion: 'vittal brinda a sus socios acceso a importantes centros de diagnóstico por imágenes y atención domiciliaria.',
      imagen: 'assets/img/home/icons-5.png',
      link: 'servicios-adicionales/radiologia'
    },
    {
      titulo: 'Vacuna antigripal',
      descripcion: 'Para la comodidad del socio y su familia, aplicamos la vacuna antigripal a domicilio.',
      imagen: 'assets/img/home/icons-6.png',
      link: 'servicios-adicionales/vacuna-antigripal-a-domicilio'
    },
    {
      titulo: 'Vacuna y tests del dengue',
      descripcion: 'Aplicación de la vacuna contra el dengue y test de detección rápida del del virus a domicilio.',
      imagen: 'assets/img/home/icons-7.png',
      link: 'servicios-adicionales/vacuna-dengue'
    }
  ];

 slideConfig = {
  slidesToShow: 4,
  slidesToScroll: 1,
  dots: true,
  infinite: true,
  arrows: true,
  autoplay: false,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1, // Mostrar solo un elemento en pantallas pequeñas
        slidesToScroll: 1,
        arrows: true,
        dots: true,
      }
    }
  ]
};
  ngOnInit() {}
}